export default __webpack_public_path__ + "static/media/logo-black.4694ae0a.png";